import { render, staticRenderFns } from "./DialogueEditor.vue?vue&type=template&id=c2babc22&scoped=true&"
import script from "./DialogueEditor.vue?vue&type=script&lang=js&"
export * from "./DialogueEditor.vue?vue&type=script&lang=js&"
import style0 from "./DialogueEditor.vue?vue&type=style&index=0&id=c2babc22&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2babc22",
  null
  
)

export default component.exports